import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SettingsBase } from '../../../../shared/services/settings/settings.service';

export const settingsBaseActions = createActionGroup({
  source: 'Settings Base',
  events: {
    'load settings base': emptyProps(),
    'load settings base success': props<{ settings: SettingsBase }>(),
    'load settings base failure': props<{ error: string }>(),

    'update settings base': props<{ dto: Partial<SettingsBase> }>(),
    'update settings base success': props<{ settings: SettingsBase }>(),
    'update settings base failure': props<{ error: string }>(),
  },
});
